import Armontf1 from '../../../Media/Fasilitas BSD/Armont/Fasilitas (1).webp'
import Armontf2 from '../../../Media/Fasilitas BSD/Armont/Fasilitas (2).webp'
import Armontf3 from '../../../Media/Fasilitas BSD/Armont/Fasilitas (3).webp'
import Armontf4 from '../../../Media/Fasilitas BSD/Armont/Fasilitas (4).webp'
import Armontf5 from '../../../Media/Fasilitas BSD/Armont/Fasilitas (5).webp'
import Armontf6 from '../../../Media/Fasilitas BSD/Armont/Fasilitas (6).webp'

const Armontfimages =[
Armontf1,Armontf2,Armontf3,Armontf4,Armontf5,Armontf6
]

export default Armontfimages;